import { compose, pure, createSink } from 'recompose';
import { withStoreDetail } from '../Providers/WithStoreDetail';
import { withDataLayerPush } from './withDataLayerPush';
import { withUserEmail } from '../Providers/WithUserEmail';

// This push dataLayer by render styless connected component

export const callback = ({
  dataLayerPush,
  email,
  store: {
    code: storeCode,
    currency: {
      code: currencyCode
    }
  }
}) => {
  if (storeCode && currencyCode) {
    dataLayerPush({
      storeCode,
      currencyCode,
      email,
    });
  }
};

const enhance = compose(
  pure,
  withUserEmail,
  withStoreDetail,
  withDataLayerPush,
);

export default enhance(createSink(callback));



// WEBPACK FOOTER //
// ./src/Common/GTM/WithDataLayerStoreDetail.js